<app-base-entry-dialog-template [value]="value" [formGroupRef]="formGroupRef" [isSaving]="isSaving"
                                (saveClick)="onSaveClicked()" (cancelClick)="onCancelClicked()">
  <app-chart-of-account-form
    *ngIf="value"
    [viewMode]="viewMode"
    [(formGroupRef)]="formGroupRef"
    [(value)]="value">
  </app-chart-of-account-form>
</app-base-entry-dialog-template>
